import script from "./BaseTableElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseTableElement.vue?vue&type=script&lang=ts&setup=true"

import "./BaseTableElement.vue?vue&type=style&index=0&id=6b8ce0be&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b8ce0be"]])

export default __exports__